// Dependencies
import { graphql, useStaticQuery } from 'gatsby';

const useLatestBlogPosts = () => {
  const { posts } = useStaticQuery(graphql`
    query Posts {
      posts: allWpPost(limit: 2, sort: { modified: DESC }) {
        nodes {
          ...blogPostFields
        }
      }
    }
  `);

  return posts?.nodes;
};

export default useLatestBlogPosts;
